import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { PersonSelectorService } from "../../../personselector/personselector.service";
import { DemographicsService } from "../Demographics.service";
import { MTAOverrideRequest } from "../MTAOverrideRequest";

@Component({
	selector: "app-override-mta",
	templateUrl: "./override-mta.component.html",
	styleUrls: ["./override-mta.component.css"],
})
export class OverrideMTAComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private demographicsService: DemographicsService,
		private userService: UserService,
		private confirmationService: ConfirmationService,
		private personSelectorService: PersonSelectorService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		//Get data from parent
		this.StudentName = this.dialogConfig.data.StudentName;
		this.StudentID = this.dialogConfig.data.StudentID;
		this.EnableMTA = this.dialogConfig.data.EnableMTA;
		this.EnablePARider = this.dialogConfig.data.EnablePARider;
		this.PublicTransitLabel = this.dialogConfig.data.PublicTransitLabel;

		//Get data from DB
		this.GetMTAOverrideMessage();
		this.MTAReasonGetList();
	}

	//////////////////////////////////////////
	// Data
	//////////////////////////////////////////
	EnableMTA: any = false;
	EnablePARider: any = false;

	StudentName: any = "";
	StudentID: any = "";
	MTAOverrideMessage: any = "";
	lstReason: any = [];
	SelectedReason: any;
	user: any;
	errorMessage: any = "";
	PublicTransitLabel: string = "";
	//////////////////////////////////////////

	GetMTAOverrideMessage() {
		var result = this.demographicsService.GetMTAOverrideMessage();
		result.subscribe(
			(response) => {
				this.MTAOverrideMessage = response[0].KeyValue;
			},
			(error) => {}
		);
	}

	MTAReasonGetList() {
		var result = this.demographicsService.MTAReasonGetList();
		result.subscribe(
			(response) => {
				this.lstReason = response;
				this.SelectedReason = this.lstReason[0].MTAOverrideReasonID;
			},
			(error) => {}
		);
	}

	//////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////
	onAgree() {
		//Error handling
		if (this.SelectedReason == undefined || this.SelectedReason < 1) {
			this.errorMessage = "Select a reason to override";
			return;
		}

		var SuccessMSG: any = "Rider status was changed successfully";
		var FailMSG: any = "Could Not override the Rider's Status";

		SuccessMSG = this.PublicTransitLabel + " rider status was changed successfully";
		FailMSG = "Could Not override the " + this.PublicTransitLabel + " Rider's Status";

		let parms: MTAOverrideRequest = {
			StudentID: this.StudentID,
			MTAOverrideReasonID: this.SelectedReason,
			UserID: this.user.userID,
		};

		var result = this.demographicsService.MTAOverrideToggle(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "override",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: SuccessMSG,
						header: "Success",
						icon: "fa",
						accept: () => {
							this.personSelectorService.TableRefresh("Refresh");
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "override",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: FailMSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////////
}
